<template>
  <div>
    <div class="main-title">闸机管理</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="deviceQuery" placeholder="搜索设备号或名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="deviceLoading" @click="fetchDeviceList">查询设备</el-button>
          </el-form-item>
          <el-form-item>
            <el-input v-model="authQuery.idcard" placeholder="按身份证号查询授权" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="authQuery.name" placeholder="按姓名查询授权" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="authLoading" @click="handleAuthSearch">查询授权</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="fetchCompanyList">刷新科目</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="section-title">在线设备</div>
      <el-table :data="deviceList" border stripe v-loading="deviceLoading">
        <el-table-column prop="dev_sno" label="设备号" min-width="180"></el-table-column>
        <el-table-column prop="name" label="设备名称" min-width="140"></el-table-column>
        <el-table-column prop="company_name" label="所属科目" min-width="120"></el-table-column>
        <el-table-column prop="register_no" label="注册号" min-width="100"></el-table-column>
        <el-table-column prop="through_type" label="出入口" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.through_type === '1'">出口</span>
            <span v-else-if="scope.row.through_type === '2'">入口</span>
            <span v-else>{{ scope.row.through_type || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.is_online ? 'success' : 'info'">
              {{ scope.row.is_online ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="last_heartbeat_time" label="最后心跳" min-width="160"></el-table-column>
        <el-table-column prop="last_login_time" label="最后登录" min-width="160"></el-table-column>
        <el-table-column label="配置" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editDevice(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="section-title" style="margin-top:20px;">人脸授权记录</div>
      <el-table :data="authList" border stripe v-loading="authLoading">
        <el-table-column prop="name" label="姓名" min-width="100"></el-table-column>
        <el-table-column prop="idcard" label="身份证号" min-width="180"></el-table-column>
        <el-table-column label="照片" min-width="100">
          <template slot-scope="scope">
            <img
              v-if="scope.row.photo_url"
              :src="scope.row.photo_url"
              class="face-image face-image-clickable"
              @click="previewPhoto(scope.row)"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="授权类型" min-width="110">
          <template slot-scope="scope">
            {{ formatAuthSource(scope.row.auth_source) }}
          </template>
        </el-table-column>
        <el-table-column prop="device_name" label="设备名称" min-width="120"></el-table-column>
        <el-table-column prop="dev_sno" label="设备号" min-width="160"></el-table-column>
        <el-table-column label="授权状态" min-width="100">
          <template slot-scope="scope">
            {{ formatAuthStatus(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="auth_begin_time" label="开始时间" min-width="160"></el-table-column>
        <el-table-column prop="auth_end_time" label="结束时间" min-width="160"></el-table-column>
        <el-table-column prop="last_error" label="失败原因" min-width="180"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              :disabled="['success', 'deleted', 'deleting', 'syncing'].indexOf(scope.row.sync_status) >= 0"
              @click="retryAuth(scope.row)">
              补授权
            </el-button>
            <el-button
              type="text"
              style="color:#f56c6c;"
              :disabled="['deleted', 'deleting'].indexOf(scope.row.status) >= 0"
              @click="deleteAuth(scope.row)">
              删除授权
            </el-button>
            <el-button
              type="text"
              style="color:#f56c6c;"
              @click="deletePersonAuths(scope.row)">
              删除人员
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :current-page="authPage"
          :page-size="authPageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="authTotal"
          @current-change="handleAuthPageChange"
          @size-change="handleAuthPageSizeChange">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="设备配置" :visible.sync="deviceDialogVisible" width="520px">
      <el-form :model="deviceForm" label-width="100px">
        <el-form-item label="设备号">
          <el-input v-model="deviceForm.dev_sno" disabled></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="deviceForm.name"></el-input>
        </el-form-item>
        <el-form-item label="注册号">
          <el-input v-model="deviceForm.register_no"></el-input>
        </el-form-item>
        <el-form-item label="所属科目">
          <el-select v-model="deviceForm.company_id" filterable clearable style="width:100%;">
            <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出入口">
          <el-select v-model="deviceForm.through_type" style="width:100%;">
            <el-option label="出口" value="1"></el-option>
            <el-option label="入口" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="deviceDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="deviceSaving" @click="saveDevice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="照片预览" :visible.sync="photoPreviewVisible" width="640px">
      <div class="photo-preview-content">
        <img v-if="photoPreviewUrl" :src="photoPreviewUrl" class="photo-preview-image" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    user: Object
  },
  data () {
    return {
      deviceQuery: '',
      authQuery: {
        idcard: '',
        name: ''
      },
      companyList: [],
      deviceLoading: false,
      authLoading: false,
      deviceSaving: false,
      deviceList: [],
      authList: [],
      authPage: 1,
      authPageSize: 10,
      authTotal: 0,
      deviceDialogVisible: false,
      photoPreviewVisible: false,
      photoPreviewUrl: '',
      deviceForm: {
        id: 0,
        dev_sno: '',
        name: '',
        register_no: '',
        company_id: null,
        through_type: '2'
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchDeviceList()
    this.fetchAuthList()
  },
  methods: {
    fetchCompanyList () {
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
        }
      })
    },
    fetchDeviceList () {
      this.deviceLoading = true
      this.$http.get('/gate/device/list', {
        params: {
          query: this.deviceQuery
        }
      }).then(response => {
        this.deviceLoading = false
        if (response.data.success) {
          this.deviceList = response.data.list
        } else {
          this.$message.error(response.data.message)
        }
      }).catch(() => {
        this.deviceLoading = false
      })
    },
    fetchAuthList () {
      this.authLoading = true
      this.$http.get('/gate/auth/list', {
        params: {
          ...this.authQuery,
          page: this.authPage,
          page_size: this.authPageSize
        }
      }).then(response => {
        this.authLoading = false
        if (response.data.success) {
          this.authList = response.data.list || []
          this.authTotal = response.data.total || 0
        } else {
          this.$message.error(response.data.message)
        }
      }).catch(() => {
        this.authLoading = false
      })
    },
    handleAuthSearch () {
      this.authPage = 1
      this.fetchAuthList()
    },
    handleAuthPageChange (page) {
      this.authPage = page
      this.fetchAuthList()
    },
    handleAuthPageSizeChange (pageSize) {
      this.authPage = 1
      this.authPageSize = pageSize
      this.fetchAuthList()
    },
    formatAuthSource (source) {
      if (source === 'rent') return '学员'
      if (source === 'register') return '学员'
      if (source === 'staff') return '工作人员'
      if (source === 'coach') return '教练'
      return source || '-'
    },
    formatAuthStatus (row) {
      if (row.sync_status === 'success') {
        return '已授权'
      }
      if (row.sync_status === 'waiting_device') {
        return '待补授权'
      }
      if (['pending', 'syncing', 'deleting'].indexOf(row.sync_status) >= 0) {
        return '处理中'
      }
      if (row.sync_status === 'deleted' || row.status === 'deleted') {
        return '已删除'
      }
      if (row.last_error) {
        return '失败'
      }
      return row.status || '-'
    },
    previewPhoto (row) {
      if (!row.photo_url) return
      this.photoPreviewUrl = row.photo_url
      this.photoPreviewVisible = true
    },
    deleteAuth (row) {
      this.$confirm(`确定删除 ${row.name} 的闸机授权吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/gate/face/delete', {
          auth_id: row.id
        }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message)
          } else {
            this.$message.error(response.data.message)
          }
          this.refreshAuthListAfterMutation()
        })
      })
    },
    deletePersonAuths (row) {
      this.$confirm(`确定删除 ${row.name} 的所有闸机授权吗？该人员在所有设备上的授权都将被删除。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/gate/face/delete-person', {
          person_id: row.person_id
        }).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message)
          } else {
            this.$message.error(response.data.message)
          }
          this.refreshAuthListAfterMutation()
        })
      })
    },
    retryAuth (row) {
      this.$http.post('/gate/face/retry', {
        auth_id: row.id
      }).then(response => {
        if (response.data.success) {
          this.$message.success(response.data.message)
        } else {
          this.$message.error(response.data.message)
        }
        this.refreshAuthListAfterMutation()
      })
    },
    refreshAuthListAfterMutation () {
      const maxPage = Math.max(Math.ceil(Math.max(this.authTotal - 1, 0) / this.authPageSize), 1)
      if (this.authPage > maxPage) {
        this.authPage = maxPage
      }
      this.fetchAuthList()
    },
    editDevice (row) {
      this.deviceForm = {
        id: row.id,
        dev_sno: row.dev_sno,
        name: row.name,
        register_no: row.register_no,
        company_id: row.company_id || null,
        through_type: row.through_type || '2'
      }
      this.deviceDialogVisible = true
    },
    saveDevice () {
      this.deviceSaving = true
      this.$http.post('/gate/device/update', this.deviceForm).then(response => {
        this.deviceSaving = false
        if (response.data.success) {
          this.$message.success(response.data.message)
          this.deviceDialogVisible = false
          this.fetchDeviceList()
        } else {
          this.$message.error(response.data.message)
        }
      }).catch(() => {
        this.deviceSaving = false
      })
    }
  }
}
</script>

<style scoped>
.section-title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #606266;
}

.face-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}

.face-image-clickable {
  cursor: pointer;
}

.pagination-wrap {
  margin-top: 16px;
  text-align: right;
}

.photo-preview-content {
  text-align: center;
}

.photo-preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/access/Index.vue